import $ from 'jquery';
window.$ = window.jQuery = $;

import Swal from 'sweetalert2';
window.Swal = Swal;

var jQueryBridget = require('jquery-bridget');
var Masonry = require('masonry-layout');

// make Masonry a jQuery plugin
jQueryBridget( 'masonry', Masonry, $ );

// Custom imports
import './accordion.js';
import './draggable.js';
import './fancy-box.js';
import './forms.js';
import './masonry-grid.js';
import './menu.js';
import './selects.js';
import './sliders.js';
import './smooth-scroll.js';
import './tabs.js';
// import './wip/tabs-5563.js';
import './plans.js';
